import { TextField } from '@material-ui/core';
import React, {useContext, useEffect, useState} from 'react';
import {useQueryClient} from "react-query";
import SystemContext from '../../SystemContext';

import { FormDialog } from "..";
import { useAddNote, useNotes, useUpdateNote } from '../../services/notes';
import Validator from "./NotesValidator";

const NotesDialog = (props) => {

  const classes = props.classes;
  const SystemData = useContext(SystemContext);
  const queryClient = useQueryClient();
  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    canEdit: false,
    primaryObjectUuid: null,
    noteType: "",
    noteUuid: null,
    title: 'Note',
  });

  const DisplayForm = () => {
    const extraKeys = [(dialogState.noteUuid||'dummy')]
    const note = useNotes({queryClient, extraKeys});
    const handleAddNote = useAddNote();
    const handleUpdateNote = useUpdateNote();

    if ((note && Array.isArray(note.data) && note.data.length > 0 ) || (!dialogState.noteUuid && dialogState.noteType && dialogState.primaryObjectUuid)) {
      return (
        <FormDialog
          title={dialogState.title}
          message=""
          open={dialogState.showDialog}
          record={!dialogState.noteUuid ? {primaryObjectUuid: dialogState.primaryObjectUuid, noteType: dialogState.noteType} : note.data[0]}
          dialogOptions={{maxWidth: "sm", fullWidth: false}}
          classes={classes}
          validator={Validator}
          buttons = {{
            save:{icon: "check_circle", key: "Update", label: "Update", color: "primary", disabled: (status)=>{return status.error}},
            cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
          }}
          onChange={(state) => {
            if (state.buttonPressed === "save") {
              const record = state.record;
              if (dialogState.noteUuid) {
                handleUpdateNote.mutate({
                  record,
                  extraKeys,
                  resolve: () => {
                    setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
                    if (props.afterSave) {
                      props.afterSave();
                    }
                    if (typeof props.onClose === 'function') {props.onClose()}
                  },
                  reject: (err) => {
                    SystemData.openAlert("Error Saving Note", "An unexpected error has occurred while saving the note.");
                  }
                });
              } else {
                handleAddNote.mutate({
                  record,
                  extraKeys,
                  resolve: () => {
                    setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
                    if (props.afterSave) {
                      props.afterSave();
                    }
                    if (typeof props.onClose === 'function') {props.onClose()}
                  },
                  reject: (err) => {
                    SystemData.openAlert("Error Saving Note", "An unexpected error has occurred while saving the note.");
                  }
                });
              }
            } else {
              setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
              if (typeof props.onClose === 'function') {props.onClose()}
            }
          }}
        >
          <div style={{display: "inline-block", width: 400}} checkChildren={true}>
            <TextField
              id="noteText"
              label="Note"
              placeholder="Notes"
              multiline
              variant="outlined"
            />
          </div>
        </FormDialog>
      )
    } else {
      return <></>;
    }
  }

  useEffect(()=> {
    const open = async (params) => {
      const {title, canEdit, primaryObjectUuid, noteType, noteUuid} = params;
      setDialogState({...dialogState, showDialog:true, canEdit, title, primaryObjectUuid, noteType, noteUuid});
    }
    eventBus.bind(`${props.eventPrefix}.open`, open);
    return () => {
      eventBus.unbind(`${props.eventPrefix}.open`, open);
      queryClient.invalidateQueries("Notes");
    }
  }, [dialogState, eventBus, props.eventPrefix, queryClient]);

  if (dialogState.showDialog) {
    return (
      <DisplayForm />
    )
  }
  return (<></>);
}

export default NotesDialog;
